exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slider-svg[data-v-23a39f5a] {\n  width: 162px;\n  height: 162px;\n  bottom: 8vw;\n  right: 0px;\n  position: fixed;\n  text-align: center;\n  -webkit-transition: bottom 0.2s ease-out;\n  transition: bottom 0.2s ease-out;\n  pointer-events: all;\n}\n.slider-svg.minified[data-v-23a39f5a] {\n  bottom: 5vw;\n}\n", ""]);

// exports
